module.exports = __webpack_public_path__ + "img/idcare-icon.8f32f2d5.svg";